import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { map, Subject, takeUntil } from 'rxjs';

import { HomeService } from '../home/home.service';
import { ProfileService } from './profile.service';
import { ChatService } from '../chat/chat.service';
import { LayoutService } from '../layout.service';
import { UrlService } from '../url.service';

import { GoBackButtonComponent } from '../shared/go-back-button/go-back-button.component';

import { User } from '../shared/interfaces/user';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [GoBackButtonComponent, RouterModule, CommonModule, RouterOutlet],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit, OnDestroy {
  private readonly _destroyed = new Subject<void>()

  profileId!: number
  profiles!: User[]
  profile!: User | null
  userAge!: number
  profileLiked$ = this.profileService.profileLiked$.pipe(
    map(res => {
      this.profileLiked = res
    })
  )
  profileLiked!: User | null
  isDesktop = this.layoutService.isDesktop

  constructor(
    private route: ActivatedRoute,
    private homeService: HomeService,
    private location: Location,
    private profileService: ProfileService,
    private router: Router,
    private chatService: ChatService,
    private layoutService: LayoutService,
    private urlService: UrlService
  ) {}

  ngOnInit(): void {
    if(this.router.url.includes('matches')){
      this.profileService.profile.pipe(takeUntil(this._destroyed)).subscribe(res => {
        this.profile = res
      })
      this.homeService.pageDisplayed.next('my-matches')
    } else {
      this.homeService.pageDisplayed.next('home')
    }

    this.route.params.pipe(takeUntil(this._destroyed)).subscribe((params) => {
      const id = params['id']
        return this.profileService.profileId.next(id)
    })

    this.profileService.profileLiked$.pipe(takeUntil(this._destroyed)).subscribe(res => {
      this.profileLiked = res
    })
  }

  goBack(){
    this.location.back()

    if(this.chatService.origin === 'chat') this.chatService.toggleSidenav.next(false)
  }

  setPageDisplayed(){
    if(this.urlService.getPreviousUrl()?.includes('new-encounters')){
      this.homeService.pageDisplayed.next('new-encounters')
    } else {
      return
    }
  }

  ngOnDestroy(){
    this._destroyed.next()
    this._destroyed.complete()
  }
}
